import { defineComponent, reactive, computed, ref } from "@vue/composition-api";

export default () => {
  let formErrors = ref([]);
  let formErrorMessage = ref("");
  let formShowErrors = ref(false);

  let resetFormError = () => {
    formErrors.value = [];
    formErrorMessage.value = "";
    formShowErrors.value = false;
  };

  let handleFormError = (e) => {
    let res = e.response;

    if (res.status == 422) {
      console.log(res.data.errors);
      if (res.data && res.data.errors) {
        formErrors.value = res.data.errors;
      }
    }

    if (res.data && res.data.message) {
      formErrorMessage.value = res.data.message;
    }

    formShowErrors.value = true;
  };

  let hasError = (field) => {
    return formErrors.value[field] ? "is-invalid" : null;
  };

  let hasErrorInputClass = (field) => {
    return formErrors.value[field] ? "is-invalid" : null;
  };

  return {
    formErrors,
    formErrorMessage,
    formShowErrors,
    resetFormError,
    handleFormError,
    hasError,
    hasErrorInputClass,
  };
};
